<div class="bg-white rounded-lg h-fit">
  <p class="text-sm uppercase p-4 text-center">{{ 'todayThe' | translate : { date: now() | date } }}</p>
  <div class="border-t border-gray-200"></div>
  <div class="p-8 flex gap-7 items-start">
    <div class="w-2/12">
      <ng-container *ngTemplateOutlet="svg; context: {text: 'timeCredit'}"></ng-container>
    </div>
    <div class="mt-4 md:mt-0">
      @if (accountService.credits()?.timeCredit; as timeCredit) {
        <p class="text-sm pt-2">{{ 'remaining' | translate }}</p>
        @if (timeCredit.remaining) {
          <p class="text-bleuCaliceo-300 text-3xl font-bold pb-2 pt-2">{{ timeCredit.remaining | time }}</p>
          <p class="text-sm">{{ 'ofYour' | translate }} <strong>{{ 'tempo' | translate }}</strong>
            {{ 'until' | translate }} {{ timeCredit.expiresAt | date }}</p>
        } @else {
          {{ 'noTimeCredit' | translate }}
        }
      } @else {
        <div class="w-full overflow-hidden rounded-lg h-full">
          <h2 class="py-4">{{ 'pleaseWait' | translate }}</h2>
          <div class='progress w-full h-1 bg-bleuCaliceo-300 left-right'></div>
        </div>
      }
      <button (click)="creditMyCard('carte_tempo')"
              appHoverGradient
              class="px-6 gap-2 w-full mt-4 py-3 main-btn text-center flex items-center justify-between
        font-semibold text-sm max-w-60">
        {{ 'creditMyCard' | translate }}
        <svg class="w-4 h-4" viewBox="0 0 512 512">
          <path
            d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
            fill="#ffffff"/>
        </svg>
      </button>
    </div>
  </div>
  <div class="p-8 flex gap-7 items-start border-t border-gray-200">
    <div class="w-2/12">
      <ng-container *ngTemplateOutlet="svg; context: {text: 'sessionCredit'}"></ng-container>
    </div>
    <div class="mt-4 md:mt-0">
      @if (accountService.credits()?.session; as sessionCredit) {
        <p class="text-sm">{{ 'remaining' | translate }}</p>
        @if (sessionCredit.remaining) {
          <p
            class="text-bleuCaliceo-300 text-3xl font-bold py-2">{{ sessionCredit.remaining }} {{ 'sessions' | translate }}</p>
          <p class="text-sm">{{ 'ofYour' | translate }}
            <strong>{{ 'vitalityPass' | translate }}</strong> {{ 'until' | translate }} {{ sessionCredit.expiresAt | date }}
          </p>
        } @else {
          {{ 'noSession' | translate }}
        }
      } @else {
        <div class="w-full overflow-hidden rounded-lg h-full">
          <h2 class="p-4">{{ 'pleaseWait' | translate }}</h2>
          <div class='progress w-full h-1 bg-bleuCaliceo-300 left-right'></div>
        </div>
      }
      <button (click)="creditMyCard('vitalite')"
              appHoverGradient
              class="px-6 gap-2 w-full mt-4 py-3 main-btn text-center flex items-center justify-between
        font-semibold text-sm max-w-60">
        {{ 'creditMyCard' | translate }}
        <svg class="w-4 h-4" viewBox="0 0 512 512">
          <path
            d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
            fill="#ffffff"/>
        </svg>
      </button>
      <button (click)="goToPlanning('plan')"
              class="font-semibold text-sm rounded-lg px-6 gap-5 w-full mt-4 py-3 text-center flex items-center max-w-60
        justify-between hover:border-beige hover:bg-beige bg-white text-bleuCaliceo-300 border border-bleuCaliceo-300">
        {{ 'planSession' | translate }}
        <svg class="w-4 h-4 fill-bleuCaliceo-300" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
        </svg>
      </button>
      <button (click)="onCancelSeance.emit()"
              class="font-semibold text-sm rounded-lg px-6 gap-5 w-full mt-4 py-3 text-center flex items-center max-w-60
        justify-between hover:border-beige hover:bg-beige bg-white text-bleuCaliceo-300 border border-bleuCaliceo-300">
        {{ 'cancelSession' | translate }}
        <svg class="w-4 h-4 fill-bleuCaliceo-300" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/>
        </svg>
      </button>
    </div>
  </div>
</div>

<ng-template #svg let-text="text">
  <svg class="w-14" data-name="Calque 1" height="90.36" id="Calque_1" viewBox="0 0 68.94 90.36"
       width="68.94" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <style>
        .cls-1, .cls-2 {
          fill: #fff;
        }

        .cls-3 {
          fill: #8bacdb;
        }

        .cls-2 {
          font-family: Montserrat-Bold, Montserrat, serif;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: -.01em;
        }
      </style>
    </defs>
    <path class="cls-3"
          d="m0,81.94c0,4.65,4.03,8.42,9,8.42h50.94c4.97,0,9-3.77,9-8.42V8.42c0-4.65-4.03-8.42-9-8.42H9C4.03,0,0,3.77,0,8.42v73.51Z"/>
    @if (text === 'timeCredit') {
      <text class="cls-2" transform="translate(13.11 73.84)">
        <tspan class="uppercase" x="0" y="0">{{ text | translate }}</tspan>
      </text>
    } @else {
      <text class="cls-2" transform="translate(7.5 73.84)">
        <tspan class="uppercase" x="0" y="0">{{ text | translate }}</tspan>
      </text>
    }
    <g>
      <path class="cls-1"
            d="m39.96,23.53c-.3.51-.95.69-1.47.39-.51-.3-.69-.95-.39-1.47.3-.51.95-.69,1.47-.39s.69.95.39,1.47"/>
      <path class="cls-1"
            d="m42.16,25.86c-.45.38-1.13.32-1.51-.13-.38-.45-.32-1.13.13-1.51.45-.38,1.13-.32,1.51.13.38.45.32,1.13-.13,1.51"/>
      <path class="cls-1"
            d="m43.43,28.8c-.56.2-1.17-.08-1.38-.64-.2-.56.08-1.17.64-1.38.56-.2,1.17.08,1.38.64.2.56-.08,1.17-.64,1.38"/>
      <path class="cls-1"
            d="m43.62,31.99c-.59,0-1.07-.48-1.07-1.07s.48-1.07,1.07-1.07c.59,0,1.07.48,1.07,1.07s-.48,1.07-1.07,1.07"/>
      <path class="cls-1"
            d="m42.7,35.06c-.56-.2-.84-.82-.64-1.38.2-.56.82-.84,1.38-.64.56.2.84.82.64,1.38-.2.56-.82.84-1.38.64"/>
      <path class="cls-1"
            d="m40.79,37.63c-.45-.38-.51-1.06-.13-1.51.38-.45,1.06-.51,1.51-.13.45.38.51,1.06.13,1.51-.38.46-1.06.51-1.51.13"/>
      <path class="cls-1"
            d="m38.12,39.39c-.3-.51-.12-1.17.39-1.47.51-.3,1.17-.12,1.47.39.3.51.12,1.17-.39,1.47-.51.3-1.17.12-1.46-.39"/>
      <path class="cls-1"
            d="m35.01,40.14c-.1-.58.29-1.14.87-1.24.58-.1,1.14.29,1.24.87.1.58-.29,1.14-.87,1.24-.58.1-1.14-.29-1.24-.87"/>
      <path class="cls-1"
            d="m31.82,39.77c.1-.58.66-.97,1.24-.87.58.1.97.66.87,1.24-.1.58-.66.97-1.24.87-.58-.1-.97-.66-.87-1.24"/>
      <path class="cls-1"
            d="m28.96,38.33c.3-.51.95-.69,1.47-.39s.69.95.39,1.47c-.3.51-.95.69-1.47.39-.51-.3-.69-.95-.39-1.47"/>
      <path class="cls-1"
            d="m26.76,36c.45-.38,1.13-.32,1.51.13.38.45.32,1.13-.13,1.51-.45.38-1.13.32-1.51-.13-.38-.45-.32-1.13.13-1.51"/>
      <path class="cls-1"
            d="m25.49,33.06c.56-.2,1.17.09,1.38.64.2.56-.09,1.17-.64,1.38-.56.2-1.17-.08-1.38-.64-.2-.56.08-1.17.64-1.38"/>
      <path class="cls-1"
            d="m25.3,29.87c.59,0,1.07.48,1.07,1.07s-.48,1.07-1.07,1.07c-.59,0-1.07-.48-1.07-1.07s.48-1.07,1.07-1.07"/>
      <path class="cls-1"
            d="m26.22,26.8c.56.2.84.82.64,1.38-.2.56-.82.84-1.38.64-.56-.2-.84-.82-.64-1.38.2-.56.82-.84,1.38-.64"/>
      <path class="cls-1"
            d="m28.13,24.23c.45.38.51,1.06.13,1.51-.38.45-1.06.51-1.51.13-.45-.38-.51-1.06-.13-1.51.38-.45,1.06-.51,1.51-.13"/>
      <path class="cls-1"
            d="m30.8,22.47c.3.51.12,1.17-.39,1.47-.51.29-1.17.12-1.47-.39-.3-.51-.12-1.17.39-1.47.51-.3,1.17-.12,1.47.39"/>
      <path class="cls-1"
            d="m33.92,21.73c.1.58-.29,1.14-.87,1.24-.58.1-1.14-.29-1.24-.87-.1-.58.29-1.14.87-1.24.58-.1,1.14.29,1.24.87"/>
      <path class="cls-1"
            d="m37.1,22.09c-.1.58-.66.97-1.24.87-.58-.1-.97-.66-.87-1.24.1-.58.66-.97,1.24-.87.58.1.97.66.87,1.24"/>
      <path class="cls-1"
            d="m39.89,20.11c-.27.73-1.08,1.11-1.81.84-.73-.27-1.11-1.07-.84-1.81.27-.73,1.08-1.11,1.81-.84.73.27,1.11,1.08.84,1.81"/>
      <path class="cls-1"
            d="m43.26,22.62c-.5.6-1.39.67-1.99.17-.6-.5-.67-1.39-.17-1.99.5-.6,1.39-.67,1.99-.17.6.5.67,1.39.17,1.99"/>
      <path class="cls-1"
            d="m45.57,26.13c-.67.39-1.54.16-1.93-.51-.39-.67-.16-1.54.52-1.93.68-.39,1.54-.16,1.93.52.39.67.16,1.54-.52,1.92"/>
      <path class="cls-1"
            d="m46.53,30.22c-.77.14-1.5-.38-1.63-1.14-.14-.77.38-1.5,1.14-1.63.77-.14,1.5.38,1.63,1.14s-.38,1.5-1.14,1.63"/>
      <path class="cls-1"
            d="m46.05,34.39c-.77-.13-1.28-.87-1.14-1.63.14-.77.87-1.28,1.63-1.14.77.14,1.28.87,1.14,1.63-.14.77-.87,1.28-1.63,1.14"/>
      <path class="cls-1"
            d="m44.16,38.14c-.67-.39-.91-1.25-.52-1.93.39-.67,1.25-.9,1.93-.52.68.39.91,1.25.52,1.93-.39.67-1.25.91-1.93.52"/>
      <path class="cls-1"
            d="m41.11,41.02c-.5-.6-.42-1.48.17-1.99.6-.5,1.49-.42,1.99.17.5.6.42,1.48-.18,1.99-.6.5-1.49.42-1.99-.18"/>
      <path class="cls-1"
            d="m37.25,42.68c-.27-.73.11-1.54.84-1.81.73-.27,1.54.11,1.81.84.27.73-.11,1.54-.84,1.81-.73.27-1.54-.11-1.81-.84"/>
      <path class="cls-1"
            d="m33.06,42.92c0-.78.63-1.41,1.41-1.41s1.41.63,1.41,1.41-.63,1.41-1.41,1.41c-.78,0-1.41-.63-1.41-1.41"/>
      <path class="cls-1"
            d="m29.04,41.72c.27-.73,1.07-1.11,1.81-.84.73.27,1.11,1.08.84,1.81-.27.73-1.07,1.11-1.81.84-.73-.27-1.11-1.08-.84-1.81"/>
      <path class="cls-1"
            d="m25.67,39.21c.5-.6,1.39-.67,1.99-.17.6.5.68,1.39.18,1.99-.5.6-1.39.68-1.99.17-.6-.5-.67-1.39-.17-1.99"/>
      <path class="cls-1"
            d="m23.36,35.7c.67-.39,1.54-.16,1.93.52.39.67.16,1.54-.52,1.92-.67.39-1.54.16-1.93-.52-.39-.67-.16-1.54.52-1.93"/>
      <path class="cls-1"
            d="m22.39,31.62c.77-.13,1.5.38,1.63,1.14.14.77-.38,1.5-1.14,1.63-.77.14-1.5-.38-1.63-1.14-.14-.77.38-1.5,1.14-1.63"/>
      <path class="cls-1"
            d="m22.88,27.45c.77.14,1.28.87,1.14,1.63-.14.77-.87,1.28-1.63,1.14-.77-.13-1.28-.87-1.14-1.63.13-.77.86-1.28,1.63-1.14"/>
      <path class="cls-1"
            d="m24.77,23.69c.67.39.91,1.25.52,1.93-.39.67-1.25.9-1.93.52s-.91-1.25-.52-1.93c.39-.68,1.25-.91,1.93-.52"/>
      <path class="cls-1"
            d="m27.82,20.81c.5.6.42,1.49-.18,1.99-.6.5-1.49.42-1.99-.17-.5-.6-.42-1.49.17-1.99.6-.5,1.49-.42,1.99.17"/>
      <path class="cls-1"
            d="m31.68,19.15c.27.73-.11,1.54-.84,1.81-.73.27-1.54-.11-1.81-.84-.27-.73.11-1.54.84-1.81.73-.27,1.54.11,1.81.84"/>
      <path class="cls-1"
            d="m35.87,18.91c0,.78-.63,1.41-1.41,1.41-.78,0-1.41-.63-1.41-1.41s.63-1.41,1.41-1.41c.78,0,1.41.63,1.41,1.41"/>
      <path class="cls-1"
            d="m41.16,15.3c-.18.49-.72.74-1.21.56-.49-.18-.74-.72-.57-1.21.18-.49.72-.74,1.21-.57.49.18.74.72.57,1.21"/>
      <path class="cls-1"
            d="m46.1,18.54c-.34.4-.93.45-1.33.12-.4-.34-.45-.93-.12-1.33s.93-.45,1.33-.12c.4.34.45.93.12,1.33"/>
      <path class="cls-1"
            d="m49.65,23.27c-.45.26-1.03.11-1.29-.35-.26-.45-.11-1.03.35-1.29.45-.26,1.03-.11,1.29.35.26.45.11,1.03-.35,1.29"/>
      <path class="cls-1"
            d="m51.36,28.92c-.51.09-1.01-.25-1.1-.77-.09-.51.25-1,.77-1.1.51-.09,1.01.25,1.1.77.09.51-.25,1-.77,1.1"/>
      <path class="cls-1"
            d="m51.03,34.83c-.51-.09-.86-.58-.77-1.1.09-.51.58-.86,1.1-.77.51.09.86.58.77,1.1-.09.51-.58.86-1.09.77"/>
      <path class="cls-1"
            d="m48.7,40.26c-.45-.26-.61-.84-.35-1.29.26-.45.84-.61,1.29-.35.45.26.61.84.35,1.29-.26.45-.84.61-1.29.35"/>
      <path class="cls-1"
            d="m44.66,44.57c-.34-.4-.28-.99.12-1.33.4-.34,1-.28,1.33.12.34.4.28,1-.12,1.33-.4.34-1,.28-1.33-.12"/>
      <path class="cls-1"
            d="m39.38,47.23c-.18-.49.07-1.03.56-1.21.49-.18,1.03.07,1.21.56.18.49-.07,1.03-.56,1.21-.49.18-1.03-.07-1.21-.57"/>
      <path class="cls-1" d="m33.51,47.94c0-.52.42-.94.95-.94s.95.42.95.94-.42.95-.95.95-.95-.42-.95-.95"/>
      <path class="cls-1"
            d="m27.76,46.59c.18-.49.72-.74,1.21-.56.49.18.74.72.57,1.21-.18.49-.72.74-1.21.56-.49-.18-.74-.72-.56-1.21"/>
      <path class="cls-1"
            d="m22.81,43.35c.34-.4.93-.45,1.33-.12.4.33.45.93.12,1.33-.34.4-.93.45-1.33.12-.4-.34-.45-.93-.12-1.33"/>
      <path class="cls-1"
            d="m19.27,38.62c.45-.26,1.03-.11,1.29.35.26.45.11,1.03-.35,1.29-.45.26-1.03.11-1.29-.35-.26-.45-.11-1.03.35-1.29"/>
      <path class="cls-1"
            d="m17.56,32.97c.51-.09,1,.25,1.09.77.09.51-.25,1.01-.77,1.1-.51.09-1.01-.25-1.1-.77-.09-.51.25-1.01.77-1.1"/>
      <path class="cls-1"
            d="m17.89,27.06c.51.09.86.58.77,1.1-.09.51-.58.86-1.1.77-.51-.09-.86-.58-.77-1.1.09-.51.58-.86,1.1-.77"/>
      <path class="cls-1"
            d="m20.22,21.63c.45.26.61.84.35,1.29-.26.45-.84.61-1.29.35-.45-.26-.61-.84-.35-1.29.26-.45.84-.61,1.29-.35"/>
      <path class="cls-1"
            d="m24.26,17.32c.34.4.28,1-.12,1.33-.4.34-1,.28-1.33-.12-.33-.4-.28-1,.12-1.33.4-.33,1-.28,1.33.12"/>
      <path class="cls-1"
            d="m29.54,14.66c.18.49-.08,1.03-.57,1.21-.49.18-1.03-.07-1.21-.56-.18-.49.07-1.03.56-1.21.49-.18,1.03.07,1.21.56"/>
      <path class="cls-1"
            d="m35.4,13.95c0,.52-.42.95-.95.95s-.95-.42-.94-.95c0-.52.42-.95.95-.95s.95.42.95.95"/>
      <path class="cls-1"
            d="m42.7,18.95c-.33.56-1.05.76-1.61.43-.56-.32-.76-1.05-.43-1.61.32-.56,1.05-.76,1.61-.43.56.32.76,1.05.43,1.61"/>
      <path class="cls-1"
            d="m46.3,22.49c-.5.42-1.24.35-1.66-.14s-.35-1.24.15-1.66c.5-.42,1.24-.35,1.66.15.42.5.35,1.24-.14,1.66"/>
      <path class="cls-1"
            d="m48.47,27.05c-.61.22-1.29-.09-1.51-.7-.22-.61.09-1.29.7-1.51.61-.22,1.29.09,1.51.71.22.61-.09,1.29-.7,1.51"/>
      <path class="cls-1"
            d="m48.94,32.07c-.65,0-1.18-.53-1.18-1.18s.53-1.18,1.18-1.18,1.18.53,1.18,1.18-.53,1.18-1.18,1.18"/>
      <path class="cls-1"
            d="m47.68,36.95c-.61-.22-.93-.9-.7-1.51.22-.61.9-.93,1.51-.7.61.22.93.9.7,1.51-.22.61-.9.93-1.51.7"/>
      <path class="cls-1"
            d="m44.81,41.11c-.5-.42-.56-1.16-.15-1.66.42-.5,1.16-.56,1.66-.14.5.42.56,1.16.14,1.66-.42.5-1.16.56-1.66.14"/>
      <path class="cls-1"
            d="m40.7,44.03c-.33-.56-.13-1.28.43-1.61.56-.33,1.28-.13,1.61.43.33.56.13,1.28-.43,1.61-.56.33-1.28.13-1.61-.43"/>
      <path class="cls-1"
            d="m35.84,45.38c-.11-.64.31-1.25.96-1.36.64-.11,1.25.32,1.37.96.11.64-.32,1.25-.96,1.36-.64.11-1.25-.31-1.37-.96"/>
      <path class="cls-1"
            d="m30.81,44.98c.11-.64.72-1.07,1.36-.96s1.07.72.96,1.36c-.11.64-.72,1.07-1.37.96-.64-.11-1.07-.72-.96-1.37"/>
      <path class="cls-1"
            d="m26.22,42.88c.33-.56,1.05-.76,1.61-.43.56.32.76,1.04.43,1.61-.33.56-1.05.76-1.61.43-.56-.32-.76-1.05-.43-1.61"/>
      <path class="cls-1"
            d="m22.63,39.34c.5-.42,1.24-.35,1.66.15.42.5.35,1.24-.15,1.66-.5.42-1.24.35-1.66-.14-.42-.5-.35-1.24.15-1.66"/>
      <path class="cls-1"
            d="m20.46,34.78c.61-.22,1.29.09,1.51.7.22.61-.09,1.29-.7,1.51-.61.22-1.29-.09-1.51-.7-.22-.61.09-1.29.7-1.51"/>
      <path class="cls-1"
            d="m19.98,29.76c.65,0,1.18.53,1.18,1.18,0,.65-.53,1.18-1.18,1.18s-1.18-.53-1.18-1.18.53-1.18,1.18-1.18"/>
      <path class="cls-1"
            d="m21.25,24.88c.61.22.93.9.7,1.51-.22.61-.9.93-1.51.7-.61-.22-.93-.9-.7-1.51.22-.61.9-.93,1.51-.7"/>
      <path class="cls-1"
            d="m24.11,20.72c.5.42.56,1.16.15,1.66-.42.5-1.16.56-1.66.14-.5-.42-.56-1.16-.15-1.66.42-.5,1.16-.56,1.66-.15"/>
      <path class="cls-1"
            d="m28.22,17.8c.33.56.13,1.28-.43,1.61-.56.32-1.29.13-1.61-.43-.33-.56-.13-1.28.43-1.61.56-.33,1.28-.13,1.61.43"/>
      <path class="cls-1"
            d="m33.09,16.46c.11.64-.32,1.25-.96,1.37-.64.11-1.25-.32-1.37-.96-.11-.64.32-1.25.96-1.36.64-.11,1.25.31,1.37.95"/>
      <path class="cls-1"
            d="m38.12,16.86c-.11.64-.72,1.07-1.37.96-.64-.11-1.07-.72-.96-1.36.11-.64.72-1.07,1.37-.96.64.11,1.07.72.96,1.36"/>
      <path class="cls-1"
            d="m44.33,15.02c-.16.28-.53.38-.81.22-.28-.16-.38-.53-.22-.81.16-.28.53-.38.81-.22.28.16.38.53.22.81"/>
      <path class="cls-1"
            d="m49.18,19.35c-.25.21-.62.18-.84-.07-.21-.25-.18-.62.07-.84.25-.21.62-.18.83.07.21.25.18.62-.07.83"/>
      <path class="cls-1"
            d="m52.26,25.08c-.31.11-.65-.05-.76-.35-.11-.31.05-.65.35-.76.31-.11.65.05.76.35.11.31-.05.65-.35.76"/>
      <path class="cls-1" d="m53.18,31.52c-.33,0-.59-.26-.59-.59s.27-.59.59-.59.59.27.59.59-.27.59-.59.59"/>
      <path class="cls-1"
            d="m51.85,37.89c-.31-.11-.47-.45-.35-.76.11-.31.45-.47.76-.35.31.11.47.45.35.76-.11.31-.45.47-.76.35"/>
      <path class="cls-1"
            d="m48.43,43.41c-.25-.21-.28-.58-.07-.83.21-.25.58-.28.83-.07.25.21.28.58.07.84-.21.25-.58.28-.83.07"/>
      <path class="cls-1"
            d="m43.32,47.44c-.16-.28-.07-.65.22-.81.28-.16.65-.07.81.22.16.28.07.65-.22.81-.28.16-.65.07-.81-.22"/>
      <path class="cls-1"
            d="m37.14,49.47c-.06-.32.16-.63.48-.69.32-.06.63.16.69.48.06.32-.16.63-.48.69-.32.06-.63-.16-.69-.48"/>
      <path class="cls-1"
            d="m30.63,49.26c.06-.32.36-.54.69-.48.32.06.54.36.48.69-.06.32-.36.54-.69.48-.32-.06-.54-.36-.48-.69"/>
      <path class="cls-1"
            d="m24.6,46.85c.16-.28.53-.38.81-.22.28.16.38.53.22.81-.16.28-.53.38-.81.22-.28-.16-.38-.53-.22-.81"/>
      <path class="cls-1"
            d="m19.75,42.51c.25-.21.62-.18.83.07.21.25.18.62-.07.84-.25.21-.62.18-.83-.07-.21-.25-.18-.62.07-.84"/>
      <path class="cls-1"
            d="m16.67,36.78c.31-.11.65.05.76.35.11.31-.05.65-.35.76-.31.11-.65-.05-.76-.35-.11-.31.05-.65.35-.76"/>
      <path class="cls-1" d="m15.75,30.34c.33,0,.59.27.59.59s-.27.59-.59.59-.59-.27-.59-.59.26-.59.59-.59"/>
      <path class="cls-1"
            d="m17.08,23.98c.31.11.47.45.35.76-.11.31-.45.47-.76.35-.31-.11-.47-.45-.35-.76.11-.31.45-.47.76-.35"/>
      <path class="cls-1"
            d="m20.5,18.45c.25.21.28.58.07.84-.21.25-.58.28-.83.07-.25-.21-.28-.58-.07-.84.21-.25.58-.28.84-.07"/>
      <path class="cls-1"
            d="m25.62,14.43c.16.28.07.65-.22.81-.28.16-.65.07-.81-.22-.16-.28-.07-.65.22-.81.28-.17.65-.07.81.22"/>
      <path class="cls-1"
            d="m31.8,12.4c.06.32-.16.63-.48.69-.32.06-.63-.16-.69-.48-.06-.32.16-.63.48-.69.32-.06.63.16.69.48"/>
      <path class="cls-1"
            d="m38.3,12.6c-.06.32-.36.54-.69.48s-.54-.36-.48-.69c.06-.32.36-.54.69-.48.32.06.54.36.48.69"/>
      <path class="cls-1"
            d="m29.61,31.43c0-.14.01-.28.02-.42.03-.03.03-.08.03-.12.01-.14.02-.28.04-.41.04-.06.03-.16.05-.24.03-.07.03-.17.05-.25.01-.04.02-.08.03-.12,0-.04.03-.07.04-.11.02-.08.04-.16.06-.24.01-.04.02-.08.03-.12,0-.04.03-.07.04-.1.03-.07.07-.14.08-.22.05-.06.06-.14.09-.2.03-.08.07-.13.1-.2.08-.12.13-.27.22-.38.08-.12.17-.24.24-.36.09-.11.19-.21.28-.33.2-.2.4-.41.64-.58.1-.1.23-.18.36-.25.12-.08.24-.16.38-.23.26-.15.56-.26.86-.37.16-.03.31-.11.49-.13.04,0,.08-.02.12-.03.09-.02.17-.03.26-.05.05-.01.09-.02.14-.02.06,0,.09-.01.13-.02.04-.01.1,0,.14-.01.29-.02.6-.05.9-.01.21,0,.39.02.57.05.29.02.52.09.78.14.07.03.16.04.23.08.09,0,.15.05.22.07.07.02.15.05.21.09.14.06.27.13.39.2.12.07.24.16.34.25.21.18.38.39.49.65.04.14.1.27.09.46,0,.09-.01.18-.02.27,0,.04-.03.07-.04.11-.01.04-.04.06-.04.11-.05.05-.08.12-.14.16-.05.05-.11.09-.17.13-.07.03-.14.06-.22.08-.07.03-.18.03-.27.04-.18,0-.39-.02-.54-.06-.16-.04-.31-.09-.44-.16-.01-.02-.04-.02-.05-.04,0-.01,0-.02,0-.04.02-.04.03-.08.04-.13,0-.04.03-.08.04-.13.01-.1.02-.2.04-.3.02-.2,0-.39-.03-.57-.06-.16-.09-.33-.19-.45-.04-.07-.08-.13-.14-.19-.05-.06-.11-.11-.17-.16-.24-.2-.57-.32-.98-.38-.32-.03-.7-.03-1,.02-.07,0-.1.02-.14.03-.1.01-.19.04-.27.06-.01,0-.03,0-.04.01-.01,0-.02.02-.03.02-.01,0-.03,0-.05,0s-.02.01-.04.02c-.03.01-.06.01-.09.02-.05.02-.1.05-.15.07-.17.07-.3.17-.44.26-.19.15-.38.32-.53.51-.05.06-.09.13-.15.2-.09.14-.18.28-.26.43-.07.16-.16.3-.21.48-.03.08-.07.16-.09.25-.04.02-.03.08-.04.12-.02.04-.03.08-.04.14-.01.04-.03.08-.04.13,0,.04-.03.08-.04.13-.01.05,0,.1-.02.15,0,.02-.02.04-.02.07,0,.02,0,.05-.01.07-.01.1-.04.19-.05.29-.01.1-.04.19-.05.29-.05.4-.08.82-.09,1.24.02.19-.01.42.02.59,0,.2.02.39.05.56,0,.06.03.07.02.13,0,.04,0,.1.02.14.01.04,0,.1.03.13.01.04,0,.1.03.13.02.18.1.32.14.49.08.13.12.31.21.43.03.08.08.13.11.21.04.06.09.13.14.19.08.13.2.24.3.35.11.1.24.2.37.29.07.04.14.09.21.13.07.04.16.07.23.11.06,0,.07.04.12.05.03.03.1.02.13.04.05,0,.09.03.13.04.02,0,.05,0,.08.01.03,0,.04.02.06.02.1.01.2.03.31.04.07.03.16.02.24.02.08,0,.17.01.25.02.08,0,.17,0,.25-.01.09,0,.17,0,.26-.01.21-.03.41-.07.62-.1.13-.03.26-.07.39-.1.06-.02.13-.04.19-.05.06-.02.11-.06.18-.07.05-.03.11-.05.18-.07.05-.04.12-.05.17-.07.11-.05.23-.1.33-.16.22-.11.42-.23.62-.36.09-.07.19-.13.28-.2.04-.04.09-.07.13-.11.05-.03.07-.09.14-.1.02.03.04.05.03.09-.04.12-.11.21-.19.3-.04.04-.07.09-.11.13l-.12.12c-.17.16-.36.3-.55.44-.19.14-.41.26-.63.37-.06.02-.1.06-.17.08-.05.03-.11.05-.17.08-.12.05-.24.09-.36.14-.06.02-.12.05-.19.06-.07.02-.14.03-.2.05-.13.03-.27.07-.42.09-.04.04-.15.02-.21.04-.33.05-.72.06-1.09.04-.18,0-.36-.01-.53-.04-.08-.01-.17-.01-.25-.03-.08-.02-.16-.03-.23-.05-.15-.01-.28-.05-.42-.08-.06-.02-.12-.04-.19-.06-.05-.03-.13-.03-.18-.06-.07,0-.11-.05-.18-.07-.06-.02-.12-.05-.18-.07-.22-.11-.44-.21-.62-.34-.1-.06-.2-.12-.28-.2-.09-.09-.2-.16-.29-.24-.03-.03-.05-.06-.08-.1-.11-.12-.23-.24-.32-.38-.06-.09-.14-.17-.18-.28-.02-.06-.06-.09-.08-.15-.04-.04-.05-.1-.09-.14-.08-.23-.19-.42-.23-.67-.05-.1-.07-.23-.09-.36-.03-.12-.05-.25-.06-.38-.01-.06,0-.13-.01-.21,0-.07-.02-.13-.02-.2,0-.06,0-.14,0-.22,0-.06,0-.19-.02-.21"/>
    </g>
  </svg>
</ng-template>
